var map = {
	"./ach.png": 613,
	"./ada.png": 293,
	"./avax.png": 423,
	"./bnb.png": 339,
	"./btc.png": 292,
	"./doge.png": 518,
	"./dot.png": 176,
	"./etc.png": 99,
	"./eth.png": 496,
	"./icp.png": 149,
	"./link.png": 509,
	"./ltc.png": 458,
	"./matic.png": 923,
	"./shib.png": 833,
	"./sol.png": 299,
	"./trx.png": 987,
	"./usdc.png": 610,
	"./usdt.png": 93,
	"./xlm.png": 816,
	"./xrp.png": 535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;